import {
  FilteredItem,
  FilteredItemProps,
} from '@delmonicos/shared-design-system-react/src/components/filtered-item/filtered-item';
import { TransactionModel } from '@delmonicos/shared-sdk/libs/cpms/src/libs/charge-hub-service-lib/src/wrapper/outputs/transaction/paginated/transaction.model';
import { format } from 'date-fns';

export interface TransactionCreatedBeforeFilterStateControllerProps {
  value: TransactionModel['createdAt'];
  onRemove: FilteredItemProps['onRemove'];
}

export const TransactionCreatedBeforeFilterStateController = ({
  value,
  onRemove,
}: TransactionCreatedBeforeFilterStateControllerProps): React.JSX.Element => {
  // CONTEXT ///////////////////////////////////////////////////////////////////

  // Nothing to do

  // DATA FETCHING /////////////////////////////////////////////////////////////

  const createdAt = format(value, 'yyyy-MM-dd');

  // RENDER ////////////////////////////////////////////////////////////////////

  return (
    <FilteredItem icon="calendar-date" label={createdAt} onRemove={onRemove} />
  );
};
